(function(){
  'use strict';
  function init(section){
    if(section.dataset.bound)return;section.dataset.bound='true';
    var viewport=section.querySelector('.ig__viewport'),track=section.querySelector('.ig__track');
    var originals=Array.from(track.querySelectorAll('.ig__item'));if(!originals.length)return;
    for(var repeat=0;repeat<2;repeat++)originals.forEach(function(card){track.append(card.cloneNode(true));});
    var cards=Array.from(track.querySelectorAll('.ig__item')),offset=0,last=0,visible=false,drag=null,moved=false;
    var reduced=matchMedia('(prefers-reduced-motion:reduce)');
    function cycle(){return(originals[0].offsetWidth+parseFloat(getComputedStyle(track).gap))*originals.length;}
    function access(){var r=viewport.getBoundingClientRect();cards.forEach(function(card){var b=card.getBoundingClientRect();var show=b.right>r.left&&b.left<r.right;card.inert=!show;card.setAttribute('aria-hidden',String(!show));});}
    new IntersectionObserver(function(entries){visible=entries[0].isIntersecting;}).observe(section);
    function frame(now){
      if(last&&visible&&!drag&&!reduced.matches&&!document.hidden&&!track.contains(document.activeElement))offset+=(now-last)/1000*60;
      last=now;offset=((offset%cycle())+cycle())%cycle();
      track.style.transform=reduced.matches?'none':'translateX('+(-offset)+'px)';
      if(visible)access();requestAnimationFrame(frame);
    }
    requestAnimationFrame(frame);viewport.addEventListener('scroll',access,{passive:true});
    track.addEventListener('dragstart',function(e){e.preventDefault();});
    track.addEventListener('pointerdown',function(e){if(e.button!==0||reduced.matches)return;drag={x:e.clientX,y:e.clientY,offset:offset};moved=false;});
    track.addEventListener('pointermove',function(e){if(!drag)return;var dx=e.clientX-drag.x;if(!moved&&Math.abs(e.clientY-drag.y)>Math.abs(dx)){drag=null;return;}if(Math.abs(dx)>8){moved=true;track.setPointerCapture(e.pointerId);offset=drag.offset-dx;}});
    track.addEventListener('pointerup',function(){drag=null;});track.addEventListener('pointercancel',function(){drag=null;moved=false;});
    track.addEventListener('click',function(e){if(moved){e.preventDefault();e.stopPropagation();moved=false;}},true);
  }
  function start(){document.querySelectorAll('[data-instagram-marquee]').forEach(function(section){
    if(section.dataset.bound||section.dataset.waiting)return;
    if(!('IntersectionObserver' in window)){init(section);return;}
    section.dataset.waiting='true';
    var observer=new IntersectionObserver(function(entries){
      if(entries.some(function(entry){return entry.isIntersecting;})){observer.disconnect();init(section);}
    },{rootMargin:'600px'});
    observer.observe(section);
  });}
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',start);else start();
  document.addEventListener('shopify:section:load',start);
})();
